<dialog #_innerModal eclModal [variant]="'information'" size="l"
        (modalClose)="modalClose.emit($event)">
    <header eclModalHeader>
        {{ 'easeportal.modal.SUBNATIONAL-TERRITORIAL-ENTITY' | translate }}
    </header>
    <div eclModalBody isScrollable>
        <p>{{ 'easeportal.subnational-territorial-entity-modal.CONTENT' | translate}}</p>
        <p><strong>{{ 'easeportal.subnational-territorial-entity-modal.CONFIRMATION-QUESTION' | translate}}</strong></p>
    </div>
    <footer eclModalFooter>
        <button eclButton eclModalRole="cancel" [eclModalClose]="false" variant="secondary">{{ 'easeportal.common.NO' | translate }}</button>
        <button eclButton eclModalRole="confirm" [eclModalClose]="true" variant="primary">{{ 'easeportal.common.YES' | translate }}</button>
    </footer>
</dialog>
